import { mapState } from 'vuex';
export default {
  data: function () {
    return {
      formDialog: false,
      editedItem: {},
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    buttons() {
      return [
        {
          title: this.$i18n_t('Common.create'),
          icon: 'fal fa-plus',
          action: 'addItem',
          valid: this.isIotHubManager,
        },
      ];
    },
    n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }
        return `${this.n1Protocol}://${this.n1Host}${imagePath}`;
      }
      return '';
    },
    closeForm(operation) {
      this.formDialog = false;

      if (operation) {
        this.$refs.list.fetchList();
      }
    },
    addItem() {
      this.editedItem = {};
      this.formDialog = true;
    },
    editItem(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
  },
};
